const cache = new Map();

export const translateText = async (text, targetLang) => {
  if (!text || targetLang === 'ru') return text;
  
  // Google Translate uses 'kk' for Kazakh, but the app uses 'kz'
  const gLang = targetLang === 'kz' ? 'kk' : targetLang;
  
  const cacheKey = `${gLang}_${text}`;
  if (cache.has(cacheKey)) return cache.get(cacheKey);
  
  try {
    const url = `https://translate.googleapis.com/translate_a/single?client=gtx&sl=ru&tl=${gLang}&dt=t&q=${encodeURIComponent(text)}`;
    const res = await fetch(url);
    const data = await res.json();
    const translated = data[0].map(item => item[0]).join('');
    cache.set(cacheKey, translated);
    return translated;
  } catch (err) {
    console.error('Translation error:', err);
    return text;
  }
};
